import React from "react"
import styled, { keyframes } from "styled-components"
import NoiseBg from "../assets/images/background-noise.png"

const grainKeyframes = keyframes`
  0%, 100% {
    background-position: 0 0;
  }

  10% {
    background-position: -5% -10%;
  }

  20% {
    background-position: -15% 5%;
  }

  30% {
    background-position: 7% -25%;
  }

  40% {
    background-position: 20% 25%;
  }

  50% {
    background-position: -25% 10%;
  }

  60% {
    background-position: 15% 5%;
  }

  70% {
    background-position: 0% 15%;
  }

  80% {
    background-position: 25% 35%;
  }

  90% {
    background-position: -10% 10%;
  }
`

const NoiseOverlay = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  overflow: hidden;
  pointer-events: none;
  background: url('${ NoiseBg }');
  z-index: 10;
  animation: 0.2s infinite ${grainKeyframes};
`

const Noise = () => {
  return (
    <NoiseOverlay />
  )
}

export default Noise